<template>
  <div>
    <div class="a-container-form">
      <button class="gui-btn gui-btn--red" @click.prevent="onDownloadAllFilesClick">Скачать документы одним архивом</button>
    </div>

  <!--<v-collapse-group>-->
    <div class="a-ui-tab" v-for="(document, idx) in lot.request.documents" :key="document.id">
      <!--<v-collapse-wrapper :active="true">-->
        <div class="a-ui-tab__block">
          <div class="a-ui-tab__control-panel">
            <div class="a-ui-tab__control">
              <!--<div class="a-ui-tab__arrow"></div>-->
              <div class="a-ui-tab__number-block">{{idx + 1}}</div>
              <div class="a-ui-tab__title">
                {{document.name}}
              </div>
            </div>
            <button class="gui-btn gui-btn--red u-margin-right-20"
                    @click.prevent="onCopyDocumentClick(document)"
                    :disabled="document.availableDocuments.length === 0"
                    v-if="lot.request.permissions.CAN_ADD_BID || document.permissions.CAN_EDIT_DOCUMENT">
              Скопировать документ
            </button>
          </div>

          <div class="a-container-form" v-if="document.till">
            <span class="a-width-100-percent a-color-red">
              Редактирование разрешено до <date-time tag="i" :value="document.till"></date-time>
              <div class="u-color-black a-formatted-text">{{document.tillDescription}}</div>
            </span>
          </div>

          <div class="a-container-form a-mandatory" v-if="document.passport">
            <div class="a-label ">{{$t('form.lot.document-and-signature-expiration-date')}}:</div>

            <div class="a-input-group"
                 v-if="lot.request.permissions.CAN_ADD_BID || document.permissions.CAN_EDIT_DOCUMENT">
              <div class="a-input-group__prepend ">
                <img src="@/assets/img/static/vector.svg" alt="">
              </div>
              <date-picker v-model="document.expirationDate"
                           @input="onDocExpirationDateChanged(document.id, $event)">
              </date-picker>
            </div>

            <date-time class="a-input a-input--disabled"
                       :value="document.expirationDate"
                       v-else>
            </date-time>
          </div>

          <!-- list of attached files-->
          <div class="a-ui-tab__content-block">
            <div class="a-ui-tab__content">

              <div class="a-ui-tab__file-flex-block" v-for="(file, idx) in document.files" :key="file.uid">
                <div class="a-ui-tab__file-item-left a-width-100-percent">
                  <div class="a-ui-tab__file-block-number">
                  </div>

                  <file-link :name="file.name"
                             :link="externalLink(file.uid)"
                             :size="file.size"
                             :removable="document.permissions.CAN_EDIT_DOCUMENT"
                             :signed="file.hasSign"
                             :time="file.time"
                             @onsigncheck="onFileSignCheckClick(file.num)"
                             @remove="onRemoveFileClick({ docId: document.id, fileId: file.num})"></file-link>
                </div>
              </div>

              <div class="a-ui-tab__file-flex-block" v-if="lot.request.permissions.CAN_ADD_BID || document.permissions.CAN_EDIT_DOCUMENT">
                <div class="a-ui-tab__file-item-left a-width-100-percent">
                  <div class="a-ui-tab__file-block-number">
                  </div>

                  <file-picker :mode="document.files.length == 0 ? 'link': 'button'"
                               :signing="lot.permissions.SHOULD_BE_SIGNED"
                               @prepared="onFileReady($event, { docId: document.id })">
                  </file-picker>
                </div>
              </div>
            </div>
          </div>

          <!-- document status -->
          <div class="a-container-form" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_APPROVE_DOCUMENT && document.permissions.CAN_APPROVE_DOCUMENT">
            <div class="a-label ">{{$t('form.lot.document-status')}}:</div>
            <dropdown-new class="a-input-group select-w-180" v-model="document.state">
              <option :value="enums.RequestDocumentState.NONE" :label="'request-document-state.empty'" disabled></option>
              <option :value="enums.RequestDocumentState.APPROVED" :label="'request-document-state.approved'"></option>
              <option :value="enums.RequestDocumentState.DECLINED" :label="'request-document-state.declined'"></option>
              <option :value="enums.RequestDocumentState.CONDITIONALLY_APPROVED" :label="'request-document-state.conditionally-approved'"></option>
            </dropdown-new>
            <button type="button" class="gui-btn gui-btn--red" @click="onApproveDocumentClick({ docId: document.id, verdict: document.state, reason: document.reason })">{{$t('buttons.save')}}</button>
          </div>

          <div class="a-container-form" v-if="document.state == enums.RequestDocumentState.DECLINED || document.state == enums.RequestDocumentState.CONDITIONALLY_APPROVED" >
            <textarea class="a-textarea accreditation__textarea" rows="2" :placeholder="$t('labels.reason')" v-model="document.reason"></textarea>
          </div>
        </div>

        <div class="a-ui-tab__content"
             v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST && document.permissions.CAN_ADJUST_DOCUMENT">
          <div class="a-ui-tab__file-flex-block">
            <div class="a-ui-tab__file-item-right a-width-100-percent">
              <button class="gui-btn gui-btn--red" @click.prevent="onAllowDocumentUpdateClick({ docId: document.id })">{{$t('buttons.grant-participant-editing')}}</button>
            </div>
          </div>
        </div>
      <!--</v-collapse-wrapper>-->
    </div>

    <signature-details-dialog ref="signCheck"></signature-details-dialog>
    <copy-document-dialog ref="copyDocument"></copy-document-dialog>
    <approve-changes-dialog ref="approveChanges"
                            close-on-action
                            :lot="lot"
                            section="Приложенные документы"
    ></approve-changes-dialog>
  <!--</v-collapse-group>-->
  </div>
</template>

<script>
  import RequestDocumentState from '@/api/types/request-document-state'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import CopyDocumentDialog from '@/components/common/dialogs/CopyDocumentDialog'
  import Errors from '@/api/types/errors'
  import TagsInput from "../../../../widgets/tags/index";
  import ApproveChangesDialog from "../../../common/dialogs/ApproveChangesDialog";

  export default {
    props: {
      lot: Object
    },

    components: {
      TagsInput,
      SignatureDetailsDialog,
      CopyDocumentDialog,
      ApproveChangesDialog
    },

    data: () => ({
      state: RequestDocumentState.NONE,
      reason: undefined
    }),

    methods: {
      async onFileReady(file, options) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToPublicLotDocument', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              docId: options.docId,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('unable to attach file to document', e);
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.public-lot.attaching-file-to-document.bad-signature',
            }, 'errors.public-lot.attaching-file-to-document.unknown');
          }
        })
      },

      async onRemoveFileClick(options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeFileFromPublicLotDocument', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              docId: options.docId,
              fileId: options.fileId
            });
          }
          catch(e) {
            console.error('unable to remove file from lot', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onApproveDocumentClick(options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('approveDocumentInRequest', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              docId: options.docId,
              verdict: options.verdict.valueOf(),
              reason: options.verdict == this.enums.RequestDocumentState.APPROVED ? undefined : options.reason
            });
          }
          catch(e) {
            console.error('unable to approve document attached to request', e);
            this.globalErrorHandler(e, {
              'NOT_FILLED': 'errors.public-lot.file-in-document-status-update.not-filled-or-wrong-lot-status',
            });
          }
        })
      },

      onAllowDocumentUpdateClick(options) {
        this.$refs.approveChanges.open({
          onConfirm: async (info) => {
            await this.onAllowDocumentUpdate(options, info);
          }
        })
      },

      async onAllowDocumentUpdate(options, adjustInfo) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('allowDocumentUpdate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              docId: options.docId,
              description: adjustInfo.description,
              till: adjustInfo.till
            });
          }
          catch(e) {
            console.error('failed allowing document update', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onDocExpirationDateChanged() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('updatePublicLot', this.lot);
          }
          catch(e) {
            console.error('failed updating public lot', e);
            this.globalErrorHandler(e, {
              'INVALID_STATE': 'errors.public-lot.doc-expiration-change.can-not-update-request-anymore'
            }, 'errors.public-lot.doc-expiration-change.unknown');
          }
        });
      },

      async onFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkFileOfLotDocumentSignature', {
              requestId: this.lot.request.id,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking signature of attached to lot file', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onDownloadAllFilesClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('downloadAllDocumentsFromRequest', {
              requestId: this.lot.request.id
            });
          }
          catch(e) {
            console.error('failed downloading all files from request', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onCopyDocumentClick(document) {
        this.$refs.copyDocument.open({
          options: document.availableDocuments.map((doc, i) => ({
            id: i,
            name: doc.lotNum
          })),
          onConfirm: (selectedId) => {
            this.runBlockerAction(async () => {
              try {
                await this.$store.dispatch('copyDocument', {
                  lotId: this.lot.id,
                  requestId: this.lot.request.id,
                  documentId: document.id,
                  sourceRequestId: document.availableDocuments[selectedId].request
                });
              }
              catch(e) {
                console.error('failed copying document to another request', e);
                this.globalErrorHandler(e);
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-mandatory {
    h3::after,
    .a-label::before {
      content: '*';
      color: #cc061a;
    }
  }
</style>
